import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { isRenault, STEPS, LOGO } from './../util/constants'

// Redux Actions
import { showError } from './../redux/snackbar'
import { setAppointmentNotes } from './../redux/appointmentNotes'
import { setCampaigns } from './../redux/campaigns'
import { setDealers } from './../redux/dealers'

// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Sun from '@mui/icons-material/WbSunny';
import Moon from '@mui/icons-material/Brightness3';
import Tooltip from '@mui/material/Tooltip';

// Custom
import Form0 from './Form0'
import Form1 from './Form1'
import Form2 from './Form2'
import Form25 from './Form25'
import Form3 from './Form3'
import Form4 from './Form4'
import Form5 from './Form5'
import Campaigns from './Campaigns'
import StaticMap from './StaticMap'
import Summary from './Summary'
import CustomStepper from './CustomStepper'
import CustomLinearProgress from '../components/CustomLinearProgress'
import eventBus from '../EventBus';

// Api Requests
import { getCampaigns, getAppointmentNoteCategoryParents, getDealers } from './../services/index'
import { IconButton } from '@mui/material';



function getFaviconEl() {
    return document.getElementById("favicon");
}

const paddingRoot = { xs: 0, sm: 0, md: 2, lg: 4, xl: 4 }
// const paddingRoot = { xs: 0, sm: 0, md: 2, lg: 2, xl: 2 }


const Index = (props) => {

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const activeStep = useSelector(state => state.step)
    const loading = useSelector(state => state.loading)
    const portLogin = useSelector(state => state.portLogin)

    const theme = useTheme();
    // Theme
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    const styles = {
        contentRoot: {
            minHeight: 'fit-content',
            height: 'fit-content'
        },
        leftColumnRoot: {
            minHeight: 'fit-content',
            height: 'fit-content'
        },
        rightColumnRoot: {
            minHeight: 'fit-content',
            height: 'fit-content',


        },
        label: {
            color: 'white',
            fontSize: "12px"
        },
        labelBlack: {
            color: 'black',
            fontSize: "12px"
        },
        title: xsDown ? {
            fontSize: '0.9em',
        } : smDown ? {
            fontSize: '1.6em',
        } : {
            fontSize: '1.6em',
        },
        logoButton: {
            '&:hover': {
                backgroundColor: 'transparent'
            },
            padding: "5px"
        },
        logoRenault: xsDown ? {
            height: '35px',
            width: '27px',
            marginLeft: '11px',
        } : smDown ? {
            height: '46px',
            width: '36px',
            marginLeft: '11px',
        } : {
            height: '86px',
            width: '63px',
            marginLeft: '27px',
        },
        logoDacia: smDown ? { width: '100px' } : { width: '230px' },
    }

    // Calculate spacing 
    const spacing = useMemo(() => {

        // const spacings = { xs: 2, sm: 2, md: 2, lg: 4, xl: 4 }
        const spacings = { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // On mount
    useEffect(() => {

        // Get campaings
        getCampaigns()
            .then(campaigns => {
                dispatch(setCampaigns(campaigns))
            })
            .catch(e => {
                console.error(e)
                dispatch(showError(t('UNKNOWN_ERROR')))
            })

        // Get appointment note categories
        getAppointmentNoteCategoryParents()
            .then(appointmentNoteCategoryParents => {
                dispatch(setAppointmentNotes(appointmentNoteCategoryParents))
            })
            .catch(e => {
                console.error(e)
                dispatch(showError(t('UNKNOWN_ERROR')))
            })

        // Get dealers
        getDealers()
            .then(dealers => {
                dispatch(setDealers(dealers))
            })
            .catch(e => {
                console.error(e)
                dispatch(showError(t('UNKNOWN_ERROR')))
            })

        // Page Title and favicon
        document.title = t('pageTitle')
        const favicon = getFaviconEl();
        favicon.href = LOGO.FAVICON;
        // eslint-disable-next-line
    }, [])

    const [darkModeChecked, setdarkModeChecked] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false)

    const gridRef = useRef(null);
    useEffect(() => {
        gridRef.current?.scrollTo(0, 0)
    }, [activeStep])

    function getNavBar() {
        return (
            <Grid item container xs={12} sm={12} md={12}
                justifyContent="space-between"
                alignItems="center"
                style={{ display: 'flex', textAlign: "end", margin: "10px auto" }} >

                <Grid item xs={3} align="left">
                    <IconButton
                        sx={styles.logoButton}
                        disableRipple
                        onClick={() => window.location.reload()}
                        size="large">
                        <img alt="logo" style={isRenault ? styles.logoRenault : styles.logoDacia} src={darkModeChecked ? LOGO.WHITE : LOGO.BLACK} />
                    </IconButton>
                </Grid>

                <Grid item xs={6}>
                    <Typography variant='h4' color='textPrimary' align='center' sx={styles.title} >
                        {t('title')}
                    </Typography>
                </Grid>

                <Grid item xs={3} align="right">
                    <Tooltip open={openTooltip} onClose={() => setOpenTooltip(false)} onOpen={() => setOpenTooltip(xsDown ? false : true)} title={darkModeChecked ? t('lightMode') : t('darkMode')}>
                        <IconButton
                            color="secondary"
                            onClick={
                                (c) => {
                                    eventBus.dispatch("darkMode", { isDarkMode: !darkModeChecked })
                                    setdarkModeChecked(!darkModeChecked)
                                }
                            }
                            size="large">
                            {darkModeChecked ? (<Sun style={{ verticalAlign: 'middle' }} fontSize={xsDown ? undefined : 'large'} />)
                                :
                                <Moon style={{ verticalAlign: 'middle' }} fontSize={xsDown ? undefined : 'large'} />

                            }

                        </IconButton>
                    </Tooltip>
                </Grid>

            </Grid>
        );
    }

    return (
        <Box width={1} height={1} p={paddingRoot} display='flex' style={{ padding: '0px' }} bgcolor="background.default"  >
            <Grid container spacing={spacing} alignItems="stretch" style={{ overflow: 'auto' }}>

                <Grid item xs={12}>
                    {getNavBar()}
                </Grid>
                <Grid item xs={12} >
                    <CustomStepper />
                </Grid>

                {/* Content */}
                <Grid ref={gridRef} item container xs={12}
                    spacing={spacing}
                    sx={styles.contentRoot}
                    style={{ padding: '5px', marginLeft: '0px', width: "-webkit-fill-available" }}
                >

                    {/* Step 0 */}
                    {
                        activeStep === STEPS.step0 &&
                        <>
                            {/* Campaigns */}
                            <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                <Campaigns />
                            </Grid>

                            {/* Form */}
                            <Grid container item xs={12} sm={12} md={6} sx={styles.rightColumnRoot} >
                                <Box width={1} height={1} position='relative'>

                                    {/* Loading */}
                                    <CustomLinearProgress loading={loading} />

                                    {/* Form */}
                                    <Form0 />

                                </Box>
                            </Grid>
                        </>
                    }

                    {/* Step 1 */}
                    {
                        activeStep === STEPS.step1 &&
                        <>
                            {/* Summary*/}
                            <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                <Summary />
                            </Grid>

                            {/* Form */}
                            <Grid item container xs={12} sm={12} md={6} sx={styles.rightColumnRoot}>
                                <Box width={1} height={1} position='relative'>

                                    {/* Loading */}
                                    <CustomLinearProgress loading={loading} />

                                    {/* Form */}
                                    <Form1 />

                                </Box>
                            </Grid>
                        </>
                    }

                    {/* Step 2 */}
                    {
                        activeStep === STEPS.step2 &&
                        <>
                            {/* Summary*/}
                            <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                <Summary />
                            </Grid>

                            {/* Step 2 */}
                            <Form2 />
                        </>
                    }

                    {/* Step Select Timeslot*/}
                    {
                        activeStep === STEPS.timeSlotSelect &&

                        <>
                            {/* Summary*/}
                            <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                <Summary />
                            </Grid>

                            {/* Form */}
                            <Grid item xs={12} sm={12} md={6} sx={styles.rightColumnRoot}>
                                <Box width={1} height={1} position='relative'>

                                    {/* Loading */}
                                    <CustomLinearProgress loading={loading} />

                                    {/* Form */}
                                    <Form25 />

                                </Box>
                            </Grid>
                        </>
                    }

                    {/* Step 3 */}
                    {
                        activeStep === STEPS.step3 &&
                        <>
                            {/* Summary*/}
                            <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                <Summary />
                            </Grid>

                            {/* Form */}
                            <Grid item xs={12} sm={12} md={6} sx={styles.rightColumnRoot}>
                                <Box width={1} height={1} position='relative'>

                                    {/* Loading */}
                                    <CustomLinearProgress loading={loading} />

                                    {/* Form */}
                                    <Form3 />

                                </Box>
                            </Grid>
                        </>
                    }

                    {/* Step 4 */}
                    {
                        activeStep === STEPS.step4 &&
                        <>
                            {/* Summary*/}
                            {
                                !portLogin &&
                                <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                    <Summary />
                                </Grid>
                            }

                            {/* Statik Map*/}
                            {
                                portLogin && !smDown &&
                                <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                    <StaticMap />
                                </Grid>
                            }

                            {/* Form */}
                            <Grid item xs={12} sm={12} md={6} sx={styles.rightColumnRoot}>
                                <Box width={1} height={1} position='relative'>

                                    {/* Loading */}
                                    <CustomLinearProgress loading={loading} />

                                    {/* Form */}
                                    <Form4 />

                                </Box>
                            </Grid>
                        </>
                    }

                    {/* Step 5 */}
                    {
                        activeStep === STEPS.step5 &&
                        <>
                            {/* Summary*/}
                            <Grid item xs={12} sm={12} md={6} container alignItems="baseline" sx={styles.leftColumnRoot}>
                                <Summary />
                            </Grid>

                            {/* Form */}
                            <Grid item xs={12} sm={12} md={6} sx={styles.rightColumnRoot}>
                                <Box width={1} height={1} position='relative'>

                                    {/* Loading */}
                                    <CustomLinearProgress loading={loading} />

                                    {/* Form */}
                                    <Form5 />

                                </Box>
                            </Grid>
                        </>
                    }

                </Grid>

            </Grid>
        </Box>
    )

}

export default Index